import {
    createContext,
    type FC,
    type ReactNode,
    type RefObject,
    useContext,
} from "react";
import ReactDOM from "react-dom";

export const GridOnTopContext = createContext<undefined | RefObject<HTMLDivElement | null>>(undefined);

interface Props {
    children: ReactNode;
    className?: string;
}

export const GridOnTop: FC<Props> = ({ children, className }) => {
    const container = useContext(GridOnTopContext);

    const portalEl = container?.current;

    if(!portalEl) {
        return children;
    }

    const classes = [ "pointer-events-auto" ];

    if(typeof className === "string") {
        classes.push(className);
    }

    return ReactDOM.createPortal(
        <div className={classes.join(" ")}>
            {children}
        </div>,
        portalEl
    );
};
